


import React from "react";
import PropTypes from "prop-types";
import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Layout from "../../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignContent: "center",
      alignItems: "center",
      display: "grid",
      gap: `${theme.spacing(4)}px`,
      gridArea: "content",
      justifyItems: "center",
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4)
    },
  })
);

export const Thanks = ({ location }): ReactElement => {
  const classes = useStyles();

  return (
    <Layout pathname={location.pathname}>
      <Container className={classes.root} component="main" fixed>
        <Typography component="h1" variant="h4">
          Thank you
        </Typography>
        <div>
          <p>
            Your details have now been forwarded to us. One of our team will be
            in contact with you shortly to arrange a suitable time to visit the
            property. If you have any pressing questions, please don't hesitate
            to call us on 020 7940 9940.
          </p>
          <p>
            Our bespoke valuation service includes:
          </p>
          <ul>
            <li>Assessment of Property and Investment Potential</li>
            <li>Current use suitability</li>
            <li>Alternative use possibilities</li>
            <li>Evaluation of supply and demand</li>
            <li>Knowledge of market values, trends</li>
            <li>Investment Performance Analysis</li>
            <li>Development and multiple valuations</li>
            <li>
              Professional valuations for sale, purchase and funding purposes
            </li>
          </ul>
        </div>
      </Container>
    </Layout>
  );
};

Thanks.propTypes = {
  location: PropTypes.object
};

export default Thanks;
